import { ApiMethod } from "../models/api-types.type";
import AuthClientStore from "../services/auth-client.service";
import { getDeviceId } from "../services/device-session.service";
import { trackRequest } from "../services/network-activity.service";

const apiUrl = process.env.REACT_APP_PMS_API_URL as string;

const sendRequest = (
  method: ApiMethod,
  path: string,
  // eslint-disable-next-line
  body?: any,
  authToken?: string | null,
  init?: any,
) => {
  const isJsonBody = body && !(body instanceof FormData); // Check if the body is not FormData

  return trackRequest(fetch(apiUrl + path, {
    method,
    ...(body && { body: isJsonBody ? JSON.stringify(body) : body }), // Only stringify if body is JSON
    ...init,
    headers: {
      ...(isJsonBody && (!init?.headers || !init?.headers["Content-Type"]) && {
        "Content-Type": "application/json", // Add Content-Type only for JSON body
      }),
      ...(authToken && { Authorization: `Bearer ${authToken}` }),
      // Which browser this is: the API ties sign-ins and seats to it.
      "X-Device-Id": getDeviceId(),
      ...init?.headers,
    },
  }).then((response) => {
    if (response.status >= 400) {
      throw response;
    }
    if (init?.responseType === "arraybuffer") {
      return response.arrayBuffer();
    }
    // No content (e.g. a 204 after a delete): nothing to parse, and it succeeded.
    if (response.status === 204 || response.status === 205) {
      return null;
    }
    return response.text().then((text) => (text ? JSON.parse(text) : null));
  }));
};

const sendProtectedRequest = (
  method: ApiMethod,
  path: string,
  // eslint-disable-next-line
  body?: any,
  useRefreshToken = false,
  init?: RequestInit,
) => {
  const authToken = useRefreshToken
    ? AuthClientStore.getRefreshToken()
    : AuthClientStore.getAccessToken();
  if (authToken) {
    return sendRequest(method, path, body, authToken, init);
  }
};

export const useApi = () => {
  return { sendRequest, sendProtectedRequest };
};
